export default __webpack_public_path__ + "static/media/payment-small.b5984e38.svg";